import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import './Menu.scss';
import { Link } from "react-router-dom";
import UserBadge from "../common/UserBadge/UserBadge";
import Logo from 'gruppocap-ui-fe/dist/resources/img/logo/gruppoCap.png';
import LogoBlue from './Assets/CAP_2025_Payoff_RGB_Blu.svg';
import { useTranslation } from "react-i18next";
import { Navbar } from "react-bootstrap";
import SearchModal from "../common/SearchModal/SearchModal";
import { ServiceLink, ServiceLinkWithChildren } from "../../helpers/helpers";
import {setCookie,getCookie} from "../../helpers/helpers";
import { CookieLanguageInfoEnum } from "../../helpers/enums";
import { languageHandler } from "../../reducers/language";
import Language from "../common/Language/Language";

import getMenuConfig from "../../helpers/menuConfig";

const Menu = () => {
  const cookieCutoverBannerVisible= getCookie("cutoverBannerVisible") ? getCookie("cutoverBannerVisible") != "false" : "true";
  const [searchVisible, setSearchVisible] = useState(false);
  const [cutoverBannerVisible, setCutoverBannerVisible] = useState(cookieCutoverBannerVisible);
  const { topMenuLinks, menuLinks, home, cutoverBanner } = getMenuConfig();
  let menuOptions = {
    touchStart: false,
    anTouchStartEventReached: false,
    touchScrollDirection: 'UNKNOWN',
    supportsWheel: false,
    latestTouchScreenY: -1,
    stickyPoint: 0
  };

  let lastScroll = 0;
  const header$ = document.querySelector('#header');
  const navbar$ = document.querySelector('#navbar');
  const topbar$ = document.querySelector('#topbar');
  const burgerBtn$ = document.querySelector("#navbar .mob-icons .navbar-toggler");
  const burgerCloseBtn$ = document.querySelector("#navbar .mob-menu-open .navbar-toggler");
  const dispatch = useDispatch();

  const changeLanguages = (language) => {
    setCookie({
      name: CookieLanguageInfoEnum.name,
      value: language,
      options: { path: CookieLanguageInfoEnum.path },
    });
    dispatch(languageHandler(language));
  };

  const { t } = useTranslation();

  const HandleContentLoaded = () => {
    const header$ = document.querySelector('#header');
    if(header$) {
      const navbar$ = document.querySelector('#navbar');
      const topbar$ = document.querySelector('#topbar');
      const burgerBtn$ = document.querySelector("#navbar .mob-icons .navbar-toggler");
      const burgerCloseBtn$ = document.querySelector("#navbar .mob-menu-open .navbar-toggler");
      if(topbar$ && topbar$.offsetHeight > 0) {
        menuOptions.stickyPoint = topbar$.offsetHeight;
      } else {
        menuOptions.stickyPoint = 0;
      }

      document.addEventListener('scroll', HandleMouseWheel);
      document.addEventListener('mousewheel', HandleMouseWheel);
      document.addEventListener('DOMMouseScroll', HandleMouseWheel);

      document.addEventListener("touchstart", HandleTouchStart, false);
      document.addEventListener("touchend", ExitTouchContext, false);
      document.addEventListener("touchcancel", ExitTouchContext, false);
      document.addEventListener("touchmove", HandleTouchMove, false);

      window.addEventListener('resize', HandleResize);

      // show sticky header when refresh after scrolled down
      if (window.pageYOffset > menuOptions.stickyPoint) {
        if(topbar$ && topbar$.offsetHeight > 0) {
            topbar$.classList.remove("visible");
            topbar$.style.marginBottom=navbar$.offsetHeight + "px";
        } else {
            document.querySelector("body").style.marginTop = navbar$.offsetHeight + "px";
        }
        if (navbar$) {
          navbar$.classList.add("sticky");
          navbar$.classList.remove("go-down");
        }
        if (header$) {
          header$.classList.add("bg-white");
        }
      }

      burgerBtn$.addEventListener("click", HandleNavigationMenuOpen);

      burgerCloseBtn$.addEventListener("click", HandleNavigationMenuClose);

      HandleTabMainContent();

      CyclicalNavigation();
    }
  }

  const HandleTabMainContent = () => {
    document.querySelector("#tabKeyboardMainContent a.goToCookieSettings").addEventListener("focus", function (event) {
        document.querySelector("#tabKeyboardMainContent a.goToCookieSettings").classList.add("isKeyboardLinkFocus");
        document.querySelector("#tabKeyboardMainContent").style.height = "auto";
        document.querySelector("#tabKeyboardMainContent").style.opacity = "1";
        document.querySelector("#tabKeyboardMainContent").style.padding = "10px";
    });
    document.querySelector("#tabKeyboardMainContent a.goToCookieSettings").addEventListener("focusout", function (event) {
        document.querySelector("#tabKeyboardMainContent a.goToCookieSettings").classList.remove("isKeyboardLinkFocus");
        document.querySelector("#tabKeyboardMainContent").style.height = "0";
        document.querySelector("#tabKeyboardMainContent").style.opacity = "0";
        document.querySelector("#tabKeyboardMainContent").style.padding = "0";
    });

    if(document.querySelector("#tabKeyboardMainContent a.goToChat")) {
        document.querySelector("#tabKeyboardMainContent a.goToChat").addEventListener("focus", function (event) {
            document.querySelector("#tabKeyboardMainContent a.goToChat").classList.add("isKeyboardLinkFocus");
            document.querySelector("#tabKeyboardMainContent").style.height = "auto";
            document.querySelector("#tabKeyboardMainContent").style.opacity = "1";
            document.querySelector("#tabKeyboardMainContent").style.padding = "10px";
        });
        document.querySelector("#tabKeyboardMainContent a.goToChat").addEventListener("focusout", function (event) {
            document.querySelector("#tabKeyboardMainContent a.goToChat").classList.remove("isKeyboardLinkFocus");
            document.querySelector("#tabKeyboardMainContent").style.height = "0";
            document.querySelector("#tabKeyboardMainContent").style.opacity = "0";
            document.querySelector("#tabKeyboardMainContent").style.padding = "0";
        });
    }
    document.querySelector("#tabKeyboardMainContent a.goToMainContent").addEventListener("focus", function (event) {
        document.querySelector("#tabKeyboardMainContent a.goToMainContent").classList.add("isKeyboardLinkFocus");
        document.querySelector("#tabKeyboardMainContent").style.height = "auto";
        document.querySelector("#tabKeyboardMainContent").style.opacity = "1";
        document.querySelector("#tabKeyboardMainContent").style.padding = "10px";
    });
    document.querySelector("#tabKeyboardMainContent a.goToMainContent").addEventListener("focusout", function (event) {
        document.querySelector("#tabKeyboardMainContent a.goToMainContent").classList.remove("isKeyboardLinkFocus");
        document.querySelector("#tabKeyboardMainContent").style.height = "0";
        document.querySelector("#tabKeyboardMainContent").style.opacity = "0";
        document.querySelector("#tabKeyboardMainContent").style.padding = "0";
    });
  }

  const CyclicalNavigation = () => {
    if(document.querySelector(".mob-menu-open") && window.innerWidth < 600) {
      document.querySelector("#nav-language #dropdownMenuButtonLanguage").addEventListener("keydown", function (event) {
        if(event.key === "Tab" && !event.shiftKey) {
          if (!document.querySelector("#nav-language").classList.contains("show")) {
             event.preventDefault();
             document.querySelector(".mob-menu-open .navbar-brand a").focus();
          } else {
             document.querySelector("#nav-language .dropdown-menu li:last-child a").addEventListener("keydown", function (event) {
                if (event.key === "Tab" && !event.shiftKey) {
                   event.preventDefault();
                   document.querySelector(".mob-menu-open .navbar-brand a").focus();
                }
             });
          }
        }
      });
      document.querySelector(".mob-menu-open .navbar-brand a").addEventListener("keydown", function (event) {
        if (event.key === "Tab" && event.shiftKey) {
          event.preventDefault();
          document.querySelector("#nav-language #dropdownMenuButtonLanguage").focus();
        }
      });
    } else {
      document.querySelector("#nav-topbar-menu-links li:last-child a").addEventListener("keydown", function (event) {
        if(event.key === "Tab" && !event.shiftKey) {
           event.preventDefault();
           document.querySelector(".mob-menu-open .navbar-brand a").focus();
        }
      });
      document.querySelector(".mob-menu-open .navbar-brand a").addEventListener("keydown", function (event) {
        if (event.key === "Tab" && event.shiftKey) {
          event.preventDefault();
          document.querySelector("#nav-topbar-menu-links li:last-child a").focus();
        }
      });
    }
  }

  const HandleNavigationMenuOpen = () => {
    document.querySelector("body").classList.toggle("overflow-hidden");
    document.querySelector(".navbar-collapse").style.animation="slide-in-anim 0.3s ease";
    document.querySelector("#nav-language").style.animation="slide-in-anim 0.3s ease";
    document.querySelector(".navbar-collapse .mob-menu-open").style.position="fixed";
  }

  const HandleNavigationMenuClose = () => {
    document.querySelector("body").classList.toggle("overflow-hidden");
    document.querySelector(".navbar-collapse").style.animation="slide-out-anim 0.3s ease";
    document.querySelector(".navbar-collapse .mob-menu-open").style.position="static";
  }

  const HandleTouchStart = () => {
    if (!menuOptions.anTouchStartEventReached) menuOptions.anTouchStartEventReached = true;
    menuOptions.touchStart = true;
  }

  const HandleTouchMove = (e) => {
    if (menuOptions.touchStart) {
      if (e.touches !== undefined && e.touches !== null && e.touches.length > 0) {
        const touch = e.touches[0];
        menuOptions.touchScrollDirection = menuOptions.latestTouchScreenY !== -1 ? touch.screenY < menuOptions.latestTouchScreenY ? 'DOWN' : touch.screenY > menuOptions.latestTouchScreenY ? 'UP' : 'NONE' : 'NONE';
        menuOptions.latestTouchScreenY = touch.screenY;
      }
    }
  }

  const ExitTouchContext = () => {
    menuOptions.touchStart = false;
  }

  const HandleMouseWheel = () => {
    const header$ = document.querySelector('#header');
    if(header$) {
      const navbar$ = document.querySelector('#navbar');
      const topbar$ = document.querySelector('#topbar');
      var currentScroll = window.pageYOffset;
      if (currentScroll > 0) {
        if (currentScroll > lastScroll) {
          if (currentScroll > menuOptions.stickyPoint) {
            if(topbar$ && topbar$.offsetHeight > 0) {
                topbar$.classList.remove("visible");
                topbar$.style.marginBottom=navbar$.offsetHeight + "px";
            } else {
                document.querySelector("body").style.marginTop = navbar$.offsetHeight + "px";
            }
            navbar$.classList.add("sticky");
            navbar$.classList.remove("go-down");
            header$.classList.add("bg-white");
          }
        }
      } else {
        if (!header$.classList.contains("bg-override")) {
          header$.classList.remove("bg-white");
        }
        if(topbar$ && topbar$.offsetHeight > 0) {
            topbar$.classList.remove("visible");
            topbar$.style.marginBottom = "0";
        } else {
          document.querySelector("body").style.marginTop = "0";
        }
        navbar$.classList.remove("sticky");
        navbar$.classList.remove("go-down");
      }
      lastScroll = currentScroll;
    }
  }

  const HandleResize = () => {
    menuOptions.anTouchStartEventReached = false;
    if(header$) {
      CyclicalNavigation();
    }
  }

  const showSearch = (e) => {
    e.preventDefault();
    document.body.classList.add('modal-open');
    setSearchVisible(true);
  }

  const hideSearch = (e) => {
    e.preventDefault();
    document.body.classList.remove('modal-open');
    setSearchVisible(false);
  }

  const hideBanner = (e) => {
    setCookie({
      name: "cutoverBannerVisible",
      value: false,
      options: { path: "/" },
    });
    setCutoverBannerVisible(false);
  }

  useEffect(() => {
    HandleContentLoaded();
  },[]);

  function contentCutoverBanner() {
    return {__html: cutoverBanner.content};
  }

  function CutoverBanner() {
    return         <div className="bannercutover container-fluid">
                       <div className="alert alert-dismissible" role="alert">
                           <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                               <span aria-hidden="true" onClick={hideBanner}>&times;</span>
                           </button>
                           <p dangerouslySetInnerHTML={contentCutoverBanner()}></p>
                       </div>
                   </div>
  }

  return (
    <div className="Menu" data-testid="Menu">
      <header id="header" className="bg-white bg-override">
        <div id="tabKeyboardMainContent">
          <a className="gcap-cta header-link header-link-font-color-2 goToCookieSettings" href="#ot-sdk-btn-floating">{t('private.goToCookieSettings')}</a>
          <a className="gcap-cta header-link header-link-font-color-2 goToChat" href="#chatBtn">{t('private.goToChat')}</a>
          <a className="gcap-cta header-link header-link-font-color-2 goToMainContent" href="#main">{t('private.goToTheMainContent')}</a>
        </div>
        <div className="topbar flex-column justify-content-center" id="topbar">
          <div className="container">
            <div
              className="topbar-container d-flex flex-column flex-lg-row justify-content-between">
              <div className="topbar-menu">
                <ul id="topbar-menu-links" className="topbar-menu-links">
                  {
                    topMenuLinks?.map(topMenuItem => {
                      return (
                        <li key={topMenuItem.label}>
                          <ServiceLink linkObject={topMenuItem} className="gcap-cta header-link header-link-font-color-2" />
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
              <div className="topbar-user-info d-flex justify-content-end">
                <Language changeLanguage={changeLanguages}/>
                <div id="area" className="user-info d-flex">
                  <span className="user-info__login-cta">
                    <UserBadge />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Navbar collapseOnSelect expand="lg" id="navbar">
          <div className="container">
            <div className="mobile-menu d-flex justify-content-between">
              <div className="navbar-brand">
                <ServiceLinkWithChildren className="d-block" linkObject={{ link: home, type: 'home' }}>
                  <>
                    <span className="sr-only">{t('private.headerLogoPurpose')}</span>
                    <img className="img-blue" src={LogoBlue} alt="logo CAP" />
                    <img className="img-white" src={Logo} alt="logo CAP" />
                  </>
                </ServiceLinkWithChildren>
              </div>
              <div className="mob-icons d-flex justify-content-between">
                <div className="search search-mob">
                  <Link className="header-icon" to="/" onClick={showSearch}>
                    <span className="sr-only">Search</span>
                    <span className="gc-icon-functional-search-1-col" aria-hidden="true"></span>
                  </Link>
                </div>
                <Navbar.Toggle as="button" className="navbar-toggler" type="button" data-toggle="collapse"
                  data-target="#gruppoCapNavbar"
                  aria-controls="gruppoCapNavbar" aria-expanded="false"
                  aria-label="Toggle navigation">
                  <span id="header-burger-open" className="new-burger-icon"></span>
                </Navbar.Toggle>
              </div>
            </div>
            <Navbar.Collapse id="gruppoCapNavbar">
              <div className="mob-menu-open">
                <div className="navbar-brand">
                  <Link className="d-block" to="/">
                    <span className="sr-only">{t('private.headerLogoPurpose')}</span>
                    <img src={LogoBlue} alt="logo CAP" />
                  </Link>
                </div>

                <Navbar.Toggle className="navbar-toggler" as="button" type="button" data-toggle="collapse" data-target="#gruppoCapNavbar"
                  aria-controls="gruppoCapNavbar" aria-expanded="false" aria-label="Toggle navigation">
                  <span id="header-burger-close" className="burger-close-icon gc-icon-functional-close"></span>
                </Navbar.Toggle>
              </div>
              <ul className="navbar-nav ml-auto">
                {
                  menuLinks?.map((menuItem, index) => {
                    return (
                      <li className="nav-item" key={menuItem.label + "_" + index}>
                        {
                          menuItem.label !== "" && <ServiceLink className="nav-link gcap-cta header-link" linkObject={menuItem} />
                        }
                      </li>
                    )
                  })
                }
              </ul>
              <div className="search d-none d-lg-block">
                <Link className="header-icon" to="/" onClick={showSearch}>
                  <span className="sr-only">Search</span>
                  <span className="gc-icon-functional-search-1-col" aria-hidden="true"></span>
                </Link>
              </div>
              <div className="topbar-menu">
                <ul id="nav-topbar-menu-links" className="topbar-menu-links">
                  {
                    topMenuLinks?.map((topMenuItem, index) => {
                      return (
                        <li key={topMenuItem.label + "_" + index}>
                          {
                            topMenuItem.label !== "" && <ServiceLink linkObject={topMenuItem} />
                          }
                        </li>
                      );
                    })
                  }
                </ul>
              </div>
              <div className="topbar-user-info flex-column flex-md-row justify-content-between">
                <div id="nav-area" className="user-info">
                  <span className="user-info__login-cta">
                    <UserBadge mobile={true}/>
                  </span>
                </div>
                <Language changeLanguage={changeLanguages} isMobile={true}/>
              </div>
            </Navbar.Collapse>
          </div>
        </Navbar>
        {cutoverBanner!= null && cutoverBanner.checkbox == "true" && cutoverBannerVisible && <CutoverBanner />}
      </header>
      {searchVisible && <SearchModal close={hideSearch} />}
    </div>
  )
};

Menu.propTypes = {};

export default Menu;
